module.exports = __webpack_public_path__ + "img/incumbency.58087e9b.png";